import {Component, Input} from '@angular/core';
import {OrganizationTrophyItem} from "../../../../interfaces/organization-trophy-item";
import {TrophyData} from "../../../../interfaces/trophy-data";
import {TrophyRepositoryService} from "../../../../services/trophy-repository.service";
import {GameTrophyStatus} from "../../../../enums/game-trophy-status";

@Component({
  selector: 'brt-trophies-list-item',
  templateUrl: './trophies-list-item.component.html',
  styleUrls: ['./trophies-list-item.component.scss']
})
export class TrophiesListItemComponent {

  private readonly HIDDEN_TITLE = "Versteckte Trophäe";
  private readonly HIDDEN_DESCRIPTION = "Erforschen, informieren oder quizzen und damit Trophäe freischalten.";
  @Input('item') set setItem(item: any) {

    // console.log(item);
    this.trophyRepositoryService.getTrophyById(item.trophyId).then((val) => {
      this.trophyData = val;
      this.item = item;
      // this.isComplete = this.item.progress === 1;
      this.isComplete = this.item.percentValue === 100;

      if(this.trophyData.status === GameTrophyStatus.HIDDEN && !this.isComplete) {
        this.itemTitle = this.HIDDEN_TITLE;
        this.itemDescription = this.HIDDEN_DESCRIPTION;
      } else {
        this.itemTitle = this.trophyData.name;
        this.itemDescription = this.trophyData.description;
      }

    }).catch((e) => {
      console.warn(e);
    });


  }

  item!: OrganizationTrophyItem;
  trophyData!: TrophyData;
  isComplete = false;

  itemTitle = "";
  itemDescription = "";


  constructor(private trophyRepositoryService: TrophyRepositoryService) {
  }

  protected readonly GameTrophyStatus = GameTrophyStatus;
}
